var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeedbackBell(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2070_1676)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2 8.5C2 8.89782 2.15804 9.27936 2.43934 9.56066C2.72064 9.84196 3.10218 10 3.5 10",
    stroke: "#0C9CB2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4025 3.18503L8.794 1.79303C8.88684 1.70015 8.99707 1.62647 9.11839 1.57619C9.23971 1.52591 9.36974 1.50002 9.50107 1.5C9.63239 1.49998 9.76244 1.52582 9.88378 1.57605C10.0051 1.62629 10.1154 1.69993 10.2082 1.79278C10.3011 1.88562 10.3748 1.99585 10.4251 2.11717C10.4754 2.23849 10.5012 2.36852 10.5013 2.49985C10.5013 2.63117 10.4755 2.76122 10.4252 2.88256C10.375 3.00389 10.3013 3.11415 10.2085 3.20703L8.8165 4.60003",
    stroke: "#0C9CB2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.2525 3.74755C8.71563 4.21062 8.98304 4.83399 8.99942 5.48871C9.0158 6.14343 8.77989 6.77939 8.3405 7.26505L8.2525 7.35705L7.319 8.29055C7.02019 8.58906 6.84016 8.98608 6.8125 9.40755L6.8085 9.52255V9.98955C6.8085 10.153 6.7435 10.3095 6.6285 10.425C6.58632 10.4675 6.53055 10.4938 6.47095 10.4993C6.41135 10.5048 6.35172 10.4891 6.3025 10.455L6.2675 10.425L1.575 5.73305C1.55126 5.70936 1.53243 5.68123 1.51958 5.65025C1.50674 5.61928 1.50012 5.58608 1.50012 5.55255C1.50012 5.51901 1.50674 5.48581 1.51958 5.45484C1.53243 5.42387 1.55126 5.39573 1.575 5.37205C1.674 5.27305 1.803 5.21105 1.941 5.19555L2.0105 5.19155H2.477C2.901 5.19155 3.3085 5.03705 3.6255 4.75955L3.7095 4.68105L4.643 3.74755L4.723 3.67105C5.20784 3.2266 5.84553 2.98647 6.50311 3.00072C7.16068 3.01497 7.78737 3.28251 8.2525 3.74755Z",
    stroke: "#0C9CB2",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2070_1676"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 12,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedbackBell);
export default __webpack_public_path__ + "static/media/feedback-bell.5ee4d4b4c6da715b134c3f3fefceaae8.svg";
export { ForwardRef as ReactComponent };